export default "__VITE_ASSET__Ej4URfs3__"